import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import { Card, CardContent } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { useLogin } from '@/hooks/useLogin'

export default function Login() {
  const navigate = useNavigate()
  const { mutate: login, isPending } = useLogin()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)

    login(
      { email, password },
      {
        onSuccess: () => {
          navigate('/')
        },
        onError: () => {
          setError('Login failed. Please try again.')
        },
      }
    )
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="w-full max-w-md border-border shadow-sm">
        <CardContent className="flex flex-col items-center gap-8 p-16">
          {/* Logo Section */}
          <div className="flex flex-col items-center gap-2.5">
            <img src="/logo.svg" alt="clothingcompany" />
          </div>

          {/* Heading */}
          <h1 className="text-2xl font-medium text-primary">Sign In to CAT</h1>

          {/* Form */}
          <form onSubmit={handleSubmit} className="flex w-full flex-col gap-4">
            <div className="flex flex-col gap-2">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="admin@admin.com"
                required
              />
            </div>

            <div className="flex flex-col gap-2">
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Password"
                required
              />
            </div>

            <Button type="submit" disabled={isPending} className="w-full h-10">
              {isPending ? (
                <>
                  <Loader2 className="animate-spin" />
                  Signing in...
                </>
              ) : (
                'Sign In'
              )}
            </Button>
          </form>

          {/* Error Message */}
          {error && <p className="text-sm text-destructive">{error}</p>}

          {/* Help Text */}
          <p className="text-xs text-foreground">
            Don't have an account? Contact your admin for access.
          </p>
        </CardContent>
      </Card>
    </div>
  )
}
